/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_2_Item_0_DetailInputs */

const en_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elite member status`)
};

const es_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatus de miembro élite`)
};

const de_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elite-Mitgliedsstatus`)
};

const zh_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精英（Elite）会员身份`)
};

const ar_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عضوية بمستوى Elite`)
};

const fr_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut de membre Élite`)
};

const vi_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tư cách thành viên Elite`)
};

const sw_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hadhi ya mwanachama wa Elite`)
};

const th_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถานะสมาชิกระดับ Elite`)
};

const bs_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status elitnog člana`)
};

const ja_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エリート会員資格`)
};

const ko_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`엘리트 회원 자격`)
};

const pt_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status de membro Elite`)
};

const it_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status di membro Elite`)
};

const sv_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elitmedlemsstatus`)
};

const nl_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status als elitelid`)
};

const da_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status som Elite-medlem`)
};

const nb_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elitemedlemsstatus`)
};

const fi_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elitejäsenen asema`)
};

const pl_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status członka Elite`)
};

const ru_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус элитного члена`)
};

const tr_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elit üye statüsü`)
};

const hi_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elite सदस्य का दर्जा`)
};

const id_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status anggota Elite`)
};

const ms_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status ahli Elite`)
};

const cs_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status člena Elite`)
};

const el_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ιδιότητα μέλους Elite`)
};

const he_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מעמד החברות Elite`)
};

const af_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elite-lidstatus`)
};

const hu_about_content_honor_2_item_0_detail = /** @type {(inputs: About_Content_Honor_2_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elit tagsági státusz`)
};

/**
* | output |
* | --- |
* | "Elite member status" |
*
* @param {About_Content_Honor_2_Item_0_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_2_item_0_detail = /** @type {((inputs?: About_Content_Honor_2_Item_0_DetailInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_2_Item_0_DetailInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_2_item_0_detail(inputs)
	if (locale === "de") return de_about_content_honor_2_item_0_detail(inputs)
	if (locale === "zh") return zh_about_content_honor_2_item_0_detail(inputs)
	if (locale === "ar") return ar_about_content_honor_2_item_0_detail(inputs)
	if (locale === "fr") return fr_about_content_honor_2_item_0_detail(inputs)
	if (locale === "vi") return vi_about_content_honor_2_item_0_detail(inputs)
	if (locale === "sw") return sw_about_content_honor_2_item_0_detail(inputs)
	if (locale === "th") return th_about_content_honor_2_item_0_detail(inputs)
	if (locale === "bs") return bs_about_content_honor_2_item_0_detail(inputs)
	if (locale === "ja") return ja_about_content_honor_2_item_0_detail(inputs)
	if (locale === "ko") return ko_about_content_honor_2_item_0_detail(inputs)
	if (locale === "pt") return pt_about_content_honor_2_item_0_detail(inputs)
	if (locale === "it") return it_about_content_honor_2_item_0_detail(inputs)
	if (locale === "sv") return sv_about_content_honor_2_item_0_detail(inputs)
	if (locale === "nl") return nl_about_content_honor_2_item_0_detail(inputs)
	if (locale === "da") return da_about_content_honor_2_item_0_detail(inputs)
	if (locale === "nb") return nb_about_content_honor_2_item_0_detail(inputs)
	if (locale === "fi") return fi_about_content_honor_2_item_0_detail(inputs)
	if (locale === "pl") return pl_about_content_honor_2_item_0_detail(inputs)
	if (locale === "ru") return ru_about_content_honor_2_item_0_detail(inputs)
	if (locale === "tr") return tr_about_content_honor_2_item_0_detail(inputs)
	if (locale === "hi") return hi_about_content_honor_2_item_0_detail(inputs)
	if (locale === "id") return id_about_content_honor_2_item_0_detail(inputs)
	if (locale === "ms") return ms_about_content_honor_2_item_0_detail(inputs)
	if (locale === "cs") return cs_about_content_honor_2_item_0_detail(inputs)
	if (locale === "el") return el_about_content_honor_2_item_0_detail(inputs)
	if (locale === "he") return he_about_content_honor_2_item_0_detail(inputs)
	if (locale === "af") return af_about_content_honor_2_item_0_detail(inputs)
	if (locale === "hu") return hu_about_content_honor_2_item_0_detail(inputs)
	return en_about_content_honor_2_item_0_detail(inputs)
});